import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { Form, Button, Table } from "react-bootstrap";
import { TitleHeading } from "../UIElements/headings/TitleHeading";
import styles from '../listings/forms/addpost.module.css';
import style from '../UIElements/Form_label/FormLabels.module.css'
import sty from './martcard.module.css'
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import { notifyUser, type } from '../utility/notifyUser';
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import { FileInput } from "../UIElements/input/FileInput";
import { webSiteDomain } from '../RegxConst'
import ReactPaginate from 'react-paginate';
import { DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import AsyncCreatableSelect from 'react-select/async-creatable';


const ServiceInventory = (props, selectedProduct) => {
    const { id } = useParams(); // Mart ID from URL
    const [showForm, setShowForm] = useState(false); // Toggle form visibility
    const [products, setProducts] = useState([]);
    const [productId, setProductId] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [images, setProductImage] = useState(null);
    const history = useHistory();
    const [webSite, setWebSite] = useState('');
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(1);
    const [formData, setFormData] = useState({
        id: null,
        martId: null,
        serviceName: "",
        workingHours: [],
        description: "",
        category: "",
        price: 0,
        gstPercentage: null,
        images: [],
        imageFields: [""],  // Stores input fields
        webSite: '',
    });

    const [workingHours, setWorkingHours] = useState({
        monday_open: "", monday_close: "",
        tuesday_open: "", tuesday_close: "",
        wednesday_open: "", wednesday_close: "",
        thursday_open: "", thursday_close: "",
        friday_open: "", friday_close: "",
        saturday_open: "", saturday_close: "",
        sunday_open: "", sunday_close: ""
    });

    const handleTimeChange = (timeString, day, type) => {
        setWorkingHours((prev) => {
            let updatedState = { ...prev, [`${day}_${type}`]: timeString };

            // If Monday's time is changed, apply it to all other days
            if (day === 'monday') {
                ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach(d => {
                    updatedState[`${d}_${type}`] = timeString;
                });
            }

            return updatedState;
        });

        // Validate closing time
        if (type === 'close') {
            setWorkingHours((prev) => {
                const fromTime = moment(prev[`${day}_open`], 'h:mm A');
                const toTime = moment(timeString, 'h:mm A');

                if (prev[`${day}_open`] && !toTime.isAfter(fromTime)) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [day]: 'Closing time must be after opening time'
                    }));
                } else {
                    setErrors((prevErrors) => {
                        const newErrors = { ...prevErrors };
                        delete newErrors[day];
                        return newErrors;
                    });
                }

                return prev;
            });
        }
    };

    const fetchProducts = async (page = 0) => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/mart/${id}?page=${page}`);
            if (response.status === 200) {
                setProducts(response.data.data);
                setCurrentPage(page);
                setPageCount(response.data.pageCount || 1);
            } else {
                alert("Failed to fetch product data.");
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        fetchProducts(selectedPage); // fetch products for that page
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchProducts(0);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prevErrors) => ({
            ...prevErrors,
            webSite: webSiteDomain.test(formData.webSite) || formData.webSite === '' ? '' : 'Website is not valid!',
        }));

        setWebSite(value);
    };

    const handleSizeChange = (index, field, value) => {
        const updatedSizes = [...formData.sizeStockPrices];
        updatedSizes[index][field] = value;
        setFormData({ ...formData, sizeStockPrices: updatedSizes });
    };

    const areAllSizesFilled = () => {
        return formData.sizeStockPrices.every(entry =>
            entry.size.trim() !== "" &&
            entry.stockQuantity !== "" &&
            entry.productPrice !== 0
        );
    };

    const addSizeEntry = () => {
        if (areAllSizesFilled()) {
            setFormData({
                ...formData,
                sizeStockPrices: [...formData.sizeStockPrices, { size: "", stockQuantity: "", productPrice: 0 }]
            });
        }
    };

    const handleImageUpload = async (file, index) => {
        if (!file || !file.type.startsWith("image")) {
            notifyUser("Invalid File", "Please select a valid image file", "warning");
            return;  
        }

        const formDataUpload = new FormData();
        formDataUpload.append("photo", file);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/abmgr/user/upload-pan-card`,
                formDataUpload
            );

            if (response.status === 200 && response.data) {
                const uploadedImageName = response.data; // Get the new image name

                setFormData((prev) => {
                    const updatedImages = [...prev.images];
                    updatedImages[index] = {
                        name: uploadedImageName,
                        url: `${process.env.REACT_APP_IMAGES_URL}/${uploadedImageName}`
                    };

                    return { ...prev, images: updatedImages };
                });

                // **Force refresh product data from backend**
                fetchProducts(0);

                notifyUser("Success", "Image uploaded successfully", "success");
            } else {
                notifyUser("Error", "Invalid image name received", "danger");
            }
        } catch (error) {
            console.error("Error uploading image:", error);
            notifyUser("Error", "Failed to upload image", "danger");
        }
    };


    const addImageField = () => {
        setFormData((prev) => ({
            ...prev,
            images: [
                ...prev.images,
                { name: "", url: "" }
            ]
        }));
    };

    const removeImage = (index) => {
        setFormData((prev) => {
            const updatedImages = prev.images.filter((_, i) => i !== index);

            return {
                ...prev,
                images: updatedImages
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formattedData = Object.keys(workingHours).reduce((acc, key) => {
            const [day, type] = key.split('_');
            if (!acc[day]) acc[day] = { day };
            acc[day][type === 'open' ? 'openingTime' : 'closingTime'] = workingHours[key] || null;
            return acc;
        }, {});
        const finalData = Object.values(formattedData);
        const nonEmptyImages = formData.images.filter(img => img.name && img.name.trim() !== "")
        const ProductDTO = {
            ...formData,
            martId: Number(id),
            id: currentProduct ? currentProduct.id : null,
            price: formData.price,
            images: nonEmptyImages.map(entry => entry.name),
            workingHours: finalData,
            webSite: formData.webSite,
            gstPercentage: String(formData.gstPercentage),
        };

        try {
            if (currentProduct) {
                if (nonEmptyImages.length === 0) {
                    notifyUser("Error", "Please Add Service Image", "warning");
                } else {
                    await axios.put(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/${currentProduct.id}`, ProductDTO);
                    notifyUser("Success", "Service updated successfully", "success");
                    setFormData(prev => ({
                        ...prev,
                        images: prev.images.filter(entry => entry.name && entry.name.trim() !== "")
                    }));

                    setShowForm(false);
                    await fetchProducts(0);
                }
            } else {
                // const nonEmptyImages = formData.images.filter(img => img.name && img.name.trim() !== "")
                if (nonEmptyImages.length === 0) {
                    notifyUser("Error", "Please Add Service Image", "warning");
                } else {
                    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/add`, ProductDTO);
                    notifyUser("Success", "Service added successfully", "success");
                    setFormData(prev => ({
                        ...prev,
                        images: prev.images.filter(entry => entry.name && entry.name.trim() !== "")
                    }));

                    setShowForm(false);
                    fetchProducts(0);
                }
            }
        } catch (error) {
            console.error("Error updating product:", error);
            notifyUser("Error", "Failed to update product", "danger");
        }
    };

    const handleProductMart = async (product = null) => {
        setCurrentProduct(product);
        setShowForm(true);

        if (product) {
            await fetchProducts(0);
            if (product.workingHours) {
                let formattedHours = {};

                product.workingHours.forEach(({ day, openingTime, closingTime }) => {
                    const dayLower = day.toLowerCase();
                    formattedHours[`${dayLower}_open`] = openingTime;
                    formattedHours[`${dayLower}_close`] = closingTime;
                });
                setWorkingHours(formattedHours);
            }
            setFormData({
                serviceName: product.serviceName || '',
                description: product.description || '',
                category: product.category || '',
                gstPercentage: String(product.gstPercentage) || null,
                price: product.price === 0 ? null : parseFloat(product.price),
                images: (product.images && product.images.length > 0)
                    ? product.images.map(img => ({
                        name: img,
                        url: process.env.REACT_APP_IMAGES_URL + '/' + img
                    }))
                    : [],
                webSite: product.webSite || null
            });
        } else {
            setFormData({
                serviceName: '',
                description: '',
                gstPercentage: null,
                category: '',
                price: 0,
                images: [],
                webSite: '',
            });
        }
    };

    const handleGstInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "gstPercentage" ? parseFloat(value) : value
        }));
    };



    const handleDelete = async (productId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/remove/${productId}`);
            notifyUser("Success", "Service deleted successfully", "success");

            setProducts(prevProducts => prevProducts.filter(product => product.id !== productId));
        } catch (error) {
            console.error("Error deleting product:", error);
            notifyUser("Error", "Failed to delete product", "danger");
        }
    };



    const handleWebLink = (value) => {
        setErrors((prevErrors) => ({
            ...prevErrors,
            webSite: webSiteDomain.test(value) || value === '' ? '' : 'Website is not valid!',
        }));

        setWebSite(value);
    };


    // const loadCategoryOptions = async (inputValue, callback) => {
    //     try {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/categories/suggest/${id}?q=${inputValue}`
    //         );

    //         const options = response.data.map((category) => ({
    //             label: category,
    //             value: category
    //         }));

    //         callback(options);
    //     } catch (error) {
    //         console.error("Error fetching categories:", error);
    //         callback([]);
    //     }
    // };

    const loadCategoryOptions = async (inputValue, callback) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/categories/suggest/${id}?q=${inputValue}`
            );

            let options = response.data.map((category) => ({
                label: category,
                value: category
            }));

            // Check if typed input is not already in the options
            const inputExists = options.some(opt => opt.value.toLowerCase() === inputValue.toLowerCase());

            // If input doesn't exist, add it as an option
            if (inputValue && !inputExists) {
                options = [
                    { label: `${inputValue}`, value: inputValue },
                    ...options,
                ];
            }

            callback(options);
        } catch (error) {
            console.error("Error fetching categories:", error);
            callback(inputValue ? [{ label: `Use "${inputValue}"`, value: inputValue }] : []);
        }
    };



    let rowIndex = currentPage * 15;

    return (
        <div className="admin-view-head">
            <div className="mt-4 g-2 col-md-12">
                <div className="col-md-2 add_button animated_back_button text-right">
                    <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                        handleClick={() => props.history.goBack()}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
                </div>
                <TitleHeading text='Inventory Management' />
                {!showForm ? (
                    <Button className="secondary" variant="primary" onClick={() => handleProductMart(null)}>Add New Service</Button>
                ) : (
                    <div>
                        <Button variant="danger" className="popup-close-btn" onClick={() => setShowForm(false)}>
                            &times;
                        </Button>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Service Name*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control type="text" name="serviceName" value={formData.serviceName} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Description*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control as="textarea" name="description" value={formData.description} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </Form.Group>
                            {/* <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}> <Form.Label>Category*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control type="text" name="category" value={formData.category} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </Form.Group> */}

                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                        <Form.Label>Category*</Form.Label>
                                    </div>
                                    <div className='col-md-10'>
                                        <AsyncCreatableSelect
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={loadCategoryOptions}
                                            onChange={(selectedOption) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    category: selectedOption ? selectedOption.value : '',
                                                }));
                                            }}
                                            onInputChange={(inputValue, actionMeta) => {
                                                // When user types but doesn't select, keep it in formData
                                                if (actionMeta.action === 'input-change') {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        category: inputValue,
                                                    }));
                                                }
                                            }}
                                            onCreateOption={(inputValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    category: inputValue,
                                                }));
                                            }}
                                            value={
                                                formData.category
                                                    ? { label: formData.category, value: formData.category }
                                                    : null
                                            }
                                            placeholder="Type or select category"
                                            isClearable
                                        />

                                    </div>
                                </div>
                            </Form.Group>


                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}> <Form.Label>Price*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control type="number" name="price" value={formData.price} onChange={handleInputChange} required />
                                    </div>
                                </div>

                            </Form.Group>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                        <Form.Label>GST Percentage*</Form.Label>
                                    </div>
                                    <div className='col-md-10'>
                                        <div className="input-group">
                                            <Form.Control
                                                as="select"
                                                name="gstPercentage"
                                                value={String(formData.gstPercentage)}
                                                onChange={handleGstInputChange}
                                                required
                                            >
                                                <option value="">Select GST</option>
                                                <option value={0}>0</option>
                                                <option value={5}>5</option>
                                                <option value={12}>12</option>
                                                <option value={18}>18</option>
                                                <option value={28}>28</option>
                                            </Form.Control>
                                            <div className="input-group-append">
                                                <span className="input-group-text">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form.Group>

                            <div className='col-md-10 justify-content-center p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Working Hours*</Form.Label></div>
                                {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
                                    <div key={day} className="col-md-10">
                                        <label className="col-md-2 text-md-right text-left">{day.charAt(0).toUpperCase() + day.slice(1)}</label>
                                        <TimePicker use12Hours format="h:mm A" minuteStep={1}
                                            value={workingHours[`${day}_open`] ? moment(workingHours[`${day}_open`], 'h:mm A') : null}
                                            onChange={(time, timeString) => handleTimeChange(timeString, day, 'open')}
                                            placeholder="Select AM/PM"
                                            defaultOpenValue={moment('12:00 AM', 'h:mm A')}
                                        />&nbsp; &nbsp;
                                        <TimePicker use12Hours format="h:mm A" minuteStep={1}
                                            value={workingHours[`${day}_close`] ? moment(workingHours[`${day}_close`], 'h:mm A') : null}
                                            onChange={(time, timeString) => handleTimeChange(timeString, day, 'close')}
                                            placeholder="Select AM/PM"
                                            defaultOpenValue={moment('12:00 AM', 'h:mm A')}
                                        />
                                        {errors[day] && <p style={{ color: 'red' }}>{errors[day]}</p>}
                                    </div>
                                ))}
                            </div>

                            {/* <div className='row col-md-10 p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Service Available Time</Form.Label></div>
                                <div className="col-md-10 justify-content-center mt-1">
                                    <TimePicker
                                        use12Hours
                                        format="hh:mm A"
                                        minuteStep={1}
                                        value={availableFrom ? moment(availableFrom, 'hh:mm A') : null}
                                        onChange={(time, timeString) => setAvailableFrom(timeString)} // ✅ Add this
                                        placeholder="From"
                                        defaultOpenValue={moment('12:00 AM', 'hh:mm A')}
                                    />
                                    &nbsp;&nbsp;
                                    <TimePicker
                                        use12Hours
                                        format="hh:mm A"
                                        minuteStep={1}
                                        value={availableTo ? moment(availableTo, 'hh:mm A') : null}
                                        onChange={(time, timeString) => setAvailableTo(timeString)} // ✅ Add this
                                        placeholder="To"
                                        defaultOpenValue={moment('12:00 AM', 'hh:mm A')}
                                    />

                                    {errors.time && <p style={{ color: 'red', marginTop: '5px' }}>{errors.time}</p>}
                                </div>
                            </div> */}



                            <Form.Group>
                                <div className='row col-md-10 p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}> <Form.Label>Service Images*</Form.Label></div>
                                    <div className='col-md-10 justify-content-center'>

                                        {formData.images.map((imageObj, index) => (
                                            <>
                                                <div key={index} style={{ position: "relative", marginBottom: "10px", display: "flex", }}>
                                                    <FileInput
                                                        file_url={imageObj.url || ""}
                                                        file={null} // Prevent default file input from being pre-filled
                                                        file_name={imageObj.name || ""}
                                                        disabled={false}
                                                        onFileSelect={(e) => handleImageUpload(e.target.files[0], index)}
                                                        fileFormats=".png, .jpg, .jpeg, .gif"
                                                        labelText={'Choose Image'}
                                                    />
                                                </div>
                                                {imageObj.name && (
                                                    <div className={sty.image_container}>
                                                        <img src={`${process.env.REACT_APP_IMAGES_URL}/${imageObj.name}`} alt="Service Image" className={sty.preview_image} />
                                                        <button type="button" className={sty.cancel_btn} onClick={() => removeImage(index)}>&times;</button>
                                                    </div>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}></div>
                                    <div className="col-md-10">
                                        <Button
                                            variant="secondary"
                                            onClick={addImageField}
                                            className={`mt-2 ${sty.addbtn}`}
                                            disabled={formData.images.length >= 5} // Limit to 5 images
                                        >
                                            Add Photo
                                        </Button>
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label> Service Detail </Form.Label></div>
                                    <div className="col-md-10">
                                        <input type="text" className={`form-control`}
                                            placeholder={'Enter URL'}
                                            name="webSite" value={formData.webSite}
                                            onChange={handleInputChange}
                                            noValidate />
                                        {/* {(this.state.showWWW || this.state.webSite.length > 0) ? <label className={`${styles.website_prefix_label}`}></label> : null} */}
                                        <p>{errors.webSite}</p>
                                    </div>
                                </div>
                            </Form.Group>
                            <div className="popup-buttons">
                                <Button className="secondary" variant="danger" onClick={() => setShowForm(false)}>Cancel</Button>
                                <Button className="secondary" variant="primary" type="submit">Submit</Button>
                            </div>
                        </Form>
                    </div>
                )}
                {!showForm && (
                    <div className="table-responsive"> {/* Enables responsiveness */}
                        <Table striped bordered hover className="mt-4">
                            <thead>
                                <tr>
                                    <th>S.no.</th>
                                    <th>Service Name</th>
                                    <th>Category</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.flatMap((product, productIndex) => {
                                    const globalProductIndex = currentPage * 15 + productIndex + 1
                                    return <tr key={`${productIndex}`}>
                                        <td>{globalProductIndex}</td>
                                        <td>{product.serviceName}</td>
                                        <td>{product.category}</td>
                                        <td>₹{product.price}</td>
                                        <td>{product.status}</td>
                                        <td>
                                            <Button variant="warning" onClick={() => handleProductMart(product)}>
                                                ✏️
                                            </Button>
                                        </td>
                                        <td>
                                            <Button className="delete-icon" variant="warning" onClick={() => handleDelete(product.id)}>
                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                })}
                            </tbody>

                        </Table>
                        {pageCount > 1 && (
                            <div className="pagination-container text-center">
                                <ReactPaginate
                                    previousLabel={"← Prev"}
                                    nextLabel={"Next →"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination justify-content-center"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={currentPage}
                                    disabledClassName="pagination_disable_next_prev"
                                />
                            </div>
                        )}
                    </div>

                )}
            </div>
            <br></br>
            <div className={`listings row ${styles.large_rect}`}>
                {!props.isAdmin && <LargeRectangle spot={"-1"} />}
            </div>
            <div className={`${styles.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                {!props.isAdmin && <BillBoard spot={"-1"} />}
            </div>
        </div>
    );
};

export default ServiceInventory;
